import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import { Column, Row } from '../../../../components/layout-row'
import Textblock from '../../../../components/textblock'

import styles from './features.module.scss'
import imgTransactions from './about-transactions.png'

const Features = () => (
  <div className={styles.root}>
    <Row>
      <Column className="visible-md" first limitWidth>
        <img alt="Dooer app transactions" src={imgTransactions} />
      </Column>
      <Column limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="Du ska inte behöva vara ekonom för att driva företag. Bokföring ska vara lätt att förstå, kommunicera kring och smidig att göra. Varje dag jobbar ett 30-tal produktutvecklare på Dooer med enbart ett mål, att förenkla din vardag och göra ditt företagande&nbsp;supersmidigt."
              id="about.features.local-description"
            />
          }
          subTitle={
            <FormattedHTMLMessage
              defaultMessage="Vi gör allt från våra kontor <span class='visible-xs'>runt om </span>i Sverige"
              id="about.features.local-subtitle"
            />
          }
          title={
            <FormattedMessage defaultMessage="Vi utvecklar för dig som företagare." id="about.features.local-title" />
          }
        />
      </Column>
    </Row>
  </div>
)

export default Features
